import { isNativeCapacitorRuntime } from '../services/nativeRuntime';

// iOS ruling B5 (App Store Guideline 3.1.1, 2026-10-27): the native app offers, shows and applies no
// referral reward; the web is unchanged. Keyed on the runtime, not a build flag, so the native and web
// builds keep identical flags. Pro earned on the web is still honoured in the app.
export const referralRewardsAvailable = () => !isNativeCapacitorRuntime();
